import { gql } from '@apollo/client';

export const USER_FRAGMENT = gql`
  fragment userValues on User {
    id
    firstName
    lastName
    email
    selectedYear
    role
    userGroupId
    department
    status
    language
    numberFormat
    chatbotExamplesExpanded
    activated
    assistantContext
    lastChangelogSeen
    fullName @client
    isAdmin @client
  }
`;

export const USER_SETTING_FRAGMENT = gql`
  fragment userSettingValues on User {
    id
    email
    firstName
    lastName
    department
    language
    numberFormat
    assistantContext
    lastChangelogSeen
  }
`;
